export const API_PATH = '/api';
export const LOGIN_PATH = '/account/login';
export const PARTNER_PATH = '/partner';
export const CONTEXT_PATH = '/context';
export const CONTEXT_PROPERTY_PATH = '/context-properties';
export const OUTLET_PATH = '/outlet';
export const OFFER_PATH = '/offer';
export const MEMBER_PATH = '/member';
export const DOC_PATH = '/doc';
export const COMPOSITE_PURCHASE_DOC = '/composite-purchase';
export const ENDPOINTS_PATH = '/endpoints';
export const USER_PATH = '/user';


// WEBPACK FOOTER //
// ./src/config/api.ts